const UID_LENGTHS = new Set([8, 14, 16, 20]);

export const normalizeRfidUid = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value !== 'string') throw new Error('RFID identifiers must be text.');
  const raw = value.trim();
  if (!raw) return null;
  const compact = /^[0-9a-fA-F]+$/.test(raw);
  const byteSeparated = /^[0-9a-fA-F]{2}([: -])[0-9a-fA-F]{2}(?:\1[0-9a-fA-F]{2})*$/.test(raw);
  if (!compact && !byteSeparated) {
    throw new Error('Use a hexadecimal RFID identifier, optionally separated by spaces, colons or hyphens.');
  }
  const normalized = raw.replace(/[ :-]/g, '').toUpperCase();
  if (!UID_LENGTHS.has(normalized.length)) {
    throw new Error('RFID identifiers must contain 8, 14, 16 or 20 hexadecimal characters.');
  }
  return normalized;
};

// Validate the complete CSV before the first request so a typo or duplicate
// association cannot leave a partially imported register.
export const preflightRfidImport = (rows, csvField) => {
  const values = [];
  const errors = [];
  const firstRowByUid = new Map();
  rows.forEach((row, index) => {
    const rowNumber = index + 2;
    try {
      const uid = normalizeRfidUid(row[csvField]);
      values.push(uid);
      if (!uid) return;
      if (firstRowByUid.has(uid)) {
        errors.push(`CSV row ${rowNumber}: RFID ${uid} is also mapped in row ${firstRowByUid.get(uid)}.`);
      } else {
        firstRowByUid.set(uid, rowNumber);
      }
    } catch (error) {
      values.push(null);
      errors.push(`CSV row ${rowNumber}: ${error.message}`);
    }
  });
  return { values, errors };
};

// Normal web edits never change physical tag associations or scan evidence.
export const withoutRfidFields = (row) => {
  const { old_rfid, rfid_confirmed, ...editableRow } = row;
  return editableRow;
};
